module.exports = __webpack_public_path__ + "hyperion-v2-static/img/grid_highlight_orange.bf3f4106.png";